import { Label } from "../../../components/Label";
import { Input } from "../../../components/Input";
import { Button } from "../../../components/Button";
import { Radio } from "../../../components/Radio";
import { Icon } from "../../../components/core/Icon";
import { Hairline } from "../../../components/Hairline";
import * as uuid from 'uuid';
import styles from "../../../../styles/add-category.module.scss";
import { CurrencyInput } from "../../../components/CurrencyInput";

const getEmptyEdge = (category) => ({
	name: '', 
	type: 'edge', 
	sizes: category.sizes, 
	ref_id: uuid.v4() 
})

const EdgeItem = ({ edge, onChange, onDelete }) => {
	return (
		<>
			<div className="d-flex mb-15">
				<Input
					design="four"
					floatLabel="Nome da borda"
					defaultValue={edge.name}
					onChange={(e) => onChange({ ...edge, name: e.target.value })}
					className="w-100"
				/>
				<Button design="default-icon-2" onClick={onDelete} className="ml-15" >
					<Icon name="trash-alt" size="lg" />
				</Button>
			</div>
			{
				edge.sizes.map((size, sizeIdx, sizes) => {
					return (
						<div className="d-flex mt-5">
							<div className={styles.stepName}>{size.name}</div>
							<CurrencyInput
								design="four"
								value={size.price}
								onChange={(e, m, f) => onChange({
									...edge,
									sizes: sizes.map((s, sIdx) => {
										if (sIdx == sizeIdx) {
											return { ...s, price: f }
										}
										return s;
									})
								})}
								placeholder="R$ 0,00"
								className="w-50"
							/>
						</div>
					)
				})
			}
		</>
	)
}

const SetPizzaEdgesStep = ({ category, onChange }) => {
	const handler = (e) => {
		onChange({ edges: e });
	};

	const onDeleteEdge = (edgeIndex) => {
		handler(category.edges.filter((e, eIdx) => eIdx != edgeIndex))
	}

	return (
		<>
			<Label>Esta categoria possui variedade de bordas?</Label>
			<Radio
				family="has-edges"
				value={false}
				checked={category.edges.length > 0}
				className="mb-15"
				onChange={(value) => handler([])}
			>
				Não
			</Radio>
			<Radio
				family="has-edges"
				value={true}
				checked={category.edges.length > 0}
				onChange={(value) => handler([getEmptyEdge(category)])}
			>
				Sim
			</Radio>

			{category.edges.length > 0 && (
				<>
					<Hairline />
					<Label>Quais são as bordas?</Label>
					{category.edges.map((e, eIdx, edges) => {
						return (
							<>
								<EdgeItem
									edge={e}
									onChange={(newEdge) => {
										edges[eIdx] = newEdge;
										handler(edges);
									}}
									onDelete={() => onDeleteEdge(eIdx)}
								/>
								{eIdx !== edges.length - 1 && <Hairline />}
							</>
						)
					})}
					<Button design="default-2" className="mt-20" onClick={() => handler([...category.edges, getEmptyEdge(category)])}>
						Adicionar borda
					</Button>
				</>
			)}
		</>
	);
};

export default SetPizzaEdgesStep;
